import { US_STATES } from "./us_states";
import { capitalizeEachWord } from "./utils";

$(() => {
  function autocomplete(inp, arr) {
    let currentFocus;

    inp.addEventListener("input", function () {
      const val = this.value;

      closeAllLists();

      if (!val) {
        return false;
      }

      currentFocus = -1;
      const listOfUSStatesWrapperElement = document.createElement("div");
      listOfUSStatesWrapperElement.setAttribute(
        "id",
        `${this.id}-autocomplete-list`,
      );
      listOfUSStatesWrapperElement.setAttribute("class", "autocomplete-items");
      this.parentNode.appendChild(listOfUSStatesWrapperElement);

      for (const [state, keywords] of Object.entries(arr)) {
        let match = false;

        for (const k of keywords) {
          if (k.toUpperCase().startsWith(val.toUpperCase())) {
            match = true;
          }
        }

        if (match) {
          const USStateElement = document.createElement("div");
          USStateElement.classList.add("active-item");

          USStateElement.innerHTML = `${state} <input type='hidden' value='${state}'>`;

          USStateElement.addEventListener("mousemove", function () {
            inp.setAttribute(
              "answer",
              this.getElementsByTagName("input")[0].value,
            );

            inp.value = this.getElementsByTagName("input")[0].value;
          });

          USStateElement.addEventListener("click", function () {
            inp.setAttribute(
              "answer",
              this.getElementsByTagName("input")[0].value,
            );

            inp.value = this.getElementsByTagName("input")[0].value;
            closeAllLists();
          });

          listOfUSStatesWrapperElement.appendChild(USStateElement);
        }
      }

      return undefined;
    });

    inp.addEventListener("keydown", function (event) {
      let listOfUSStatesWrapperElement = document.getElementById(
        `${this.id}-autocomplete-list`,
      );
      if (listOfUSStatesWrapperElement)
        listOfUSStatesWrapperElement =
          listOfUSStatesWrapperElement.getElementsByClassName("active-item");
      if (event.keyCode === 40) {
        currentFocus += 1;
        addActive(listOfUSStatesWrapperElement);
      } else if (event.keyCode === 38) {
        currentFocus -= 1;
        addActive(listOfUSStatesWrapperElement);
      } else if (event.keyCode === 13) {
        event.preventDefault();
        if (currentFocus > -1) {
          if (listOfUSStatesWrapperElement) {
            listOfUSStatesWrapperElement[currentFocus].click();
          }
        }
      }
    });

    const addActive = (listOfStates) => {
      if (!listOfStates) return false;
      removeActive(listOfStates);
      if (currentFocus >= listOfStates.length) currentFocus = 0;
      if (currentFocus < 0) currentFocus = listOfStates.length - 1;
      listOfStates[currentFocus].classList.add("autocomplete-active");

      const activeItem = document.querySelector(".autocomplete-active");
      inp.setAttribute(
        "answer",
        activeItem.getElementsByTagName("input")[0].value,
      );

      inp.value = activeItem.getElementsByTagName("input")[0].value;

      return undefined;
    };

    const removeActive = (listOfStates) => {
      for (let arrEl = 0; arrEl < listOfStates.length; arrEl += 1) {
        listOfStates[arrEl].classList.remove("autocomplete-active");
      }
    };

    const closeAllLists = (element) => {
      const listOfUSStatesWrapperElement =
        document.getElementsByClassName("autocomplete-items");
      for (
        let arrEl = 0;
        arrEl < listOfUSStatesWrapperElement.length;
        arrEl += 1
      ) {
        if (
          element !== listOfUSStatesWrapperElement[arrEl] &&
          element !== inp
        ) {
          listOfUSStatesWrapperElement[arrEl].parentNode.removeChild(
            listOfUSStatesWrapperElement[arrEl],
          );
        }
      }
    };

    document.addEventListener("click", function (event) {
      closeAllLists(event.target);
    });

    inp.addEventListener("blur", function (event) {
      const matchesState = Object.keys(US_STATES).some((item) =>
        item.toLowerCase().includes(this.value.toLowerCase()),
      );
      const validStateEntered = Object.keys(US_STATES)
        .filter((state) => state === event.target.value)
        .toString();

      if (matchesState) {
        const capitalizedInputValue = capitalizeEachWord(this.value);
        this.setAttribute("answer", capitalizedInputValue);
        this.setAttribute("value", capitalizedInputValue);
        this.value = capitalizeEachWord(this.value);
      }

      const USStateErrorElement = document.querySelector(".us-state-error");
      const BackEndUSStateErrorElement = document.querySelector(
        ".error[for*='us_state']",
      );
      if (validStateEntered) {
        USStateErrorElement.classList.remove("show");
      } else if (!BackEndUSStateErrorElement) {
        USStateErrorElement.classList.add("show");
      }

      event.target.value = event.target.value.trim();
    });
  }

  const errorMessage = document.querySelector("#coverage-us-state-error");

  if (errorMessage) {
    EventTracker.trigger("us_state_error_message_displayed");
  }

  $(document).ready(function () {
    const elem = document.querySelector(".coverage_us_state--autocomplete");

    if (!elem) {
      return;
    }
    // On state pre-fill, form_question_answered and state_question_answered
    // events will be triggered at the same time
    if (elem.value) {
      EventTracker.trigger(
        "state_question_answered",
        $(".coverage_us_state--autocomplete"),
      );
    }
    autocomplete(elem, US_STATES);
  });
});
